<template>
  <div
    class="field is-horizontal"
    :class="{ 'dust-wipe-no-passing': localFigure.noPassing }"
  >
    <div
      class="field-body dust-figures field-grouped-half-fix"
      :class="`figure-${index}`"
    >
      <div
        class="field location"
        :class="{ 'm-none': localFigure.type === 'no-window' }"
      >
        <div class="control is-expanded">          
          <!-- Figure textbox or dropdown goes here -->
          <control-and-bedroom-textbox
            v-if="dropdownOrTextbox==='textbox'"
            :name="`${localFigure.roomNumber}-${localFigure.type}`"
            :room-number="localFigure.roomNumber"
            :type="localFigure.type"
            :location="localFigure.location"
            :property-type="propertyType"
          />
          <bedroom-dropdown
            v-if="dropdownOrTextbox==='dropdown-bedroom'"
            v-model="localFigure.location"
            :name="`${localFigure.roomNumber}-${localFigure.type}`"
            :room-number="localFigure.roomNumber"
            :type="localFigure.type"
            :index="index"
          />
          <common-area-dropdown
            v-if="dropdownOrTextbox==='dropdown-common-areas'"
            v-model="localFigure.type"
            :name="`${localFigure.roomNumber}-${localFigure.type}`"
            :room-number="localFigure.roomNumber"
            :property-type="propertyType"
          />
        </div>
      </div>
      <!-- Figure value goes here -->
      <dust-wipe-value
        v-show="localFigure.type !== 'no-window'"
        v-model="localFigure.value"
        :enable-tippy="localFigure.noPassing"
        :name="`${localFigure.roomNumber}-${localFigure.type}-value`"
        class="dust-wipe-value"
      />
    </div>
  </div>
</template>

<script>
import DustWipeValue from './DustWipeValue';
import BedroomDropdown from './BedroomDropdown';
import CommonAreaDropdown from './CommonAreaDropdown';
import ControlAndBedroomTextbox from './ControlAndBedroomTextbox';

export default {
  name: 'DustWipeFigure',
  components: {
    DustWipeValue,
    BedroomDropdown,
    CommonAreaDropdown,
    ControlAndBedroomTextbox,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    uuid: {
      type: String,
      default: '',
    },

    propertyType: {
      type: String,
      required: true,
      // validator: (value) => {
      //   return [ 'Residential', 'Daycare' ].indexOf(value) !== -1;
      // },
    },

    passing: {
      type: Boolean,
      required: false,
      default: true,
    },

    /**
     * This is the v-model!
     * The value object has all the information for a full Dust wipe sample:
     * {
     *  location: ['front', 'middle', 'rear', ''],
     *  value: Number,
     *  type: ['window', 'floor', 'control', 'no-window'],
     * }
     */
    value: {
      type: Object,
      required: true,
      validator(prop) {
        // if ([ 'window', 'floor', 'control', 'no-window' ].indexOf(prop.type) === -1) {
        //   throw new Error("Figure type accepts only [ 'window', 'floor', 'control', 'no-window' ]");
        // }
        // if ([ 'front', 'middle', 'rear', '' ].indexOf(prop.location) === -1) {
        //   throw new Error("Figure location accepts only [ 'front', 'middle', 'rear', '' ]");
        // }

        if (prop.value !== null && typeof prop.value !== 'number') {
          throw new Error("Figure value accepts only numeric values");
        }

        // if(typeof prop.roomNumber !== 'number') {
        //   throw new Error("Figure roomNumber accepts only null or a Number");
        // }

        return true;
      },
    },
  },
  computed: {
    // Here we calculate te logic behind all those types of figures
    dropdownOrTextbox() {
      if (this.localFigure.roomNumber === -1) {
        return 'textbox'; // It is control value
      }

      if (this.localFigure.roomNumber === 0
        && this.localFigure.type === 'floor') {
        return 'textbox'; // It is first floor common area
      }

      if (this.propertyType === 'Residential') {
        if (this.localFigure.roomNumber === 0) {
          return 'dropdown-common-areas'; // It is residential common area
        }
        if (this.localFigure.roomNumber >= 1) {
          if (this.index % 2 === 1) {
            return 'dropdown-bedroom';
          }
          return 'textbox'; // It is residential bedrooms
        }
        // if (this.localFigure.roomNumber >= 1) {
        // }
      } else {
        if (this.localFigure.type === 'floor') {
          return 'textbox';
        } 
        return 'dropdown-common-areas';
      }

      return '';
    },
    localFigure: {
      get() {
        return this.value;
      },
      set(localFigure) {
        // if (['front', 'middle', 'rear'].includes(localFigure.location)) {
        //   this.$emit('new-location', [localFigure.location, this.index]);
        // }
        this.$emit('input', localFigure);
      },
      deep: true,
      cache: false,
    },
  },
  watch: {
    'localFigure.type'(newType) {
      if (newType === 'no-window') {
        this.localFigure.value = 0;
      }
    },
    'localFigure.value' () {
      this.checkPassing();
    },
  },
  created() {
    this.checkPassing(); // TODO: This is not working on refresh.
  },
  methods: {
    checkPassing() {
      if (this.localFigure.type === 'control') {
        this.localFigure.noPassing = (this.localFigure.value > this.$store.state.thresholds[this.localFigure.type]);  
      } else {
        this.localFigure.noPassing = (this.localFigure.value >= this.$store.state.thresholds[this.localFigure.type]);
      }
    },
  },
};
</script>
<style lang="scss">
  .dust-wipe-wrong-icon {
    display: none;
  }
  .dust-wipe-field {
    select, input {
      padding-left: 2rem;
    }
    .helper-icon {
      position: absolute;
      top: 50%;
      margin-top: -0.5rem;
      left: 0.5rem;
      line-height: 1rem;
    }
  }
</style>
<style lang="scss" scoped>
 .dust-figures {
    .location {
      width: 70%;
    }
    @include until($tablet) {
      .location {
        width: auto;
      }
    }
  }
</style>